import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { KFLInput } from '@kamstrup/kamstrup-frontend-library';
import { ReduxState } from '../../interfaces';
import { useLifecycle } from '../../hooks/useLifecycle';
import * as Orders from '../../modules/orders';
import SidebarForm from './sidebarForm';
import { Groups } from '../../models';
import { resetScroll } from '../../modules/datatable';
import { LocaleCtx } from '../../contexts/locale.context';

interface StateProps {
  filterCriteria: Orders.FilterCriteria;
  isLoading: boolean;
}

type Props = StateProps & { id: string };

const OrderSidebar: React.FC<Props> = (props) => {
  useLifecycle('OrderSidebar');
  const [orderNumber, setOrderNumber] = useState(
    props.filterCriteria.orderNumber
  );

  const handleSearch = () => {
    const criteria = { ...props.filterCriteria, orderNumber };
    Orders.updateFilterCriteria(criteria, props.isLoading);
    resetScroll();
  };

  const handleClear = () => setOrderNumber('');

  const { translate } = useContext(LocaleCtx);
  const orderNumberTranslated = translate(Orders.msgOrder);
  return (
    <SidebarForm
      group={Groups.ORDERS}
      fnSearch={handleSearch}
      fnClear={handleClear}
      isLoading={props.isLoading}
    >
      <KFLInput
        id="sb_orders_filter_id"
        label={orderNumberTranslated}
        placeholder={orderNumberTranslated}
        value={String(orderNumber)}
        onChange={setOrderNumber}
      />
    </SidebarForm>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  isLoading: state.ordersState.table.isLoading,
  filterCriteria: state.ordersState.filters,
});

export default connect(mapStateToProps)(OrderSidebar);
